import { render } from "./AcampantesPage.vue?vue&type=template&id=5608534e&scoped=true"
import script from "./AcampantesPage.vue?vue&type=script&lang=js"
export * from "./AcampantesPage.vue?vue&type=script&lang=js"

import "./AcampantesPage.vue?vue&type=style&index=0&id=5608534e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5608534e"]])

export default __exports__